export default "__VITE_ASSET__DR95GY23__"